import React, { useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import shape1 from '../../assets/algo-right.png';
import shape2 from '../../assets/algo-left.png';
// import algo1 from '../../assets/platforms/1.png';
// import algo2 from '../../assets/platforms/2.png';
// import algo3 from '../../assets/platforms/3.png';
// import algo4 from '../../assets/platforms/4.png';
// import algo5 from '../../assets/platforms/5.png';
// import algo6 from '../../assets/platforms/6.png';
// import algo7 from '../../assets/platforms/7.png';
import s1 from '../../assets/tech-stack/1.png';
import s2 from '../../assets/tech-stack/2.png';
import s3 from '../../assets/tech-stack/3.png';
import s4 from '../../assets/tech-stack/4.png';
import s5 from '../../assets/tech-stack/5.png';
import s6 from '../../assets/tech-stack/6.png';
import s7 from '../../assets/tech-stack/7.png';
import s8 from '../../assets/tech-stack/8.png';
import s9 from '../../assets/tech-stack/9.png';
import s10 from '../../assets/tech-stack/10.png';
import s11 from '../../assets/tech-stack/11.png';
import s12 from '../../assets/tech-stack/12.png';
import s13 from '../../assets/tech-stack/13.png';
import s14 from '../../assets/tech-stack/14.png';
import s15 from '../../assets/tech-stack/15.png';
import divider from '../../assets/divider-img.png';
import steps from '../../assets/algo-steps.png';

const ServicesDriveAlgo = () => {
  const sliderRef = useRef(null);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0);
    }
  }, []);

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 2000,
    autoplay: true,
    autoplaySpeed: 1200,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };
  return (
    <div className="home-services">
      <div className="container">
        <div className="section-top service-explore-top">
          <h2> How We Drive Algo Trading Success</h2>
          <div className="divider">
            <img src={divider} alt="divider" />
          </div>
          <p>
            In the fast-paced world of algorithmic trading, success is driven by
            a combination of rigorous research, precise implementation,
            continuous optimization, and flawless execution. At Quantome, we
            pride ourselves on mastering each of these facets, ensuring that our
            clients have the edge in a competitive landscape.
          </p>
        </div>
        <div className="services-wrapper">
          <div className="algo-drive-steps">
            <img src={steps} alt="Steps" />
          </div>
          {/* <div className="service-item algo-drive-item">
            <h3>Research</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nLorem
            </p>
          </div>
          <div className="service-item algo-drive-item m-lr">
            <h3>Implementation of Strategy</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nLorem
            </p>
          </div>
          <div className="service-item algo-drive-item m-r">
            <h3>Parameter Optimisation</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nLorem
            </p>
          </div>

          <div className="service-item algo-drive-item">
            <h3>Live Execution</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nLorem
            </p>
          </div> */}
        </div>
        <div className="section-top service-explore-top algo-drive-top">
          <h2> How We Drive Algo Trading Success</h2>
          <div className="divider">
            <img src={divider} alt="divider" />
          </div>
          <p>
            Welcome to our Algorithmic Trading service, where cutting-edge
            technology meets the financial markets. Our automated trading
            strategies leverage powerful algorithms to execute trades with speed
            and precision
          </p>
        </div>
      </div>
      <div className="algo-drive-bottom">
        <div className="algo-drive-bottom-main">
          <div className="algo-companies">
            <img className="algo-shape" src={shape2} alt="algo shape" />
            {/* <div className="algo-companies-inner">
              <img className="comp-logo" src={algo1} alt="trading companies" />
              <img className="comp-logo" src={algo2} alt="trading companies" />
              <img className="comp-logo" src={algo3} alt="trading companies" />
              <img className="comp-logo" src={algo4} alt="trading companies" />
              <img className="comp-logo" src={algo5} alt="trading companies" />
              <img className="comp-logo" src={algo6} alt="trading companies" />
              <img className="comp-logo" src={algo7} alt="trading companies" />
            </div> */}

            <div className="algo-companies-inner custom-slider-container">
              <Slider ref={sliderRef} {...sliderSettings}>
                <div className="main-comp-logo">
                  <img className="comp-logo" src={s1} alt="trading companies" />
                </div>
                <div className="main-comp-logo">
                  <img className="comp-logo" src={s2} alt="trading companies" />
                </div>
                <div className="main-comp-logo">
                  <img className="comp-logo" src={s3} alt="trading companies" />
                </div>
                <div className="main-comp-logo">
                  <img className="comp-logo" src={s4} alt="trading companies" />
                </div>
                <div className="main-comp-logo">
                  <img className="comp-logo" src={s5} alt="trading companies" />
                </div>
                <div className="main-comp-logo">
                  <img className="comp-logo" src={s6} alt="trading companies" />
                </div>
                <div className="main-comp-logo">
                  <img className="comp-logo" src={s7} alt="trading companies" />
                </div>
                <div className="main-comp-logo">
                  <img className="comp-logo" src={s8} alt="trading companies" />
                </div>
                <div className="main-comp-logo">
                  <img className="comp-logo" src={s9} alt="trading companies" />
                </div>
                <div className="main-comp-logo">
                  <img
                    className="comp-logo"
                    src={s10}
                    alt="trading companies"
                  />
                </div>
                <div className="main-comp-logo">
                  <img
                    className="comp-logo"
                    src={s11}
                    alt="trading companies"
                  />
                </div>
                <div className="main-comp-logo">
                  <img
                    className="comp-logo"
                    src={s12}
                    alt="trading companies"
                  />
                </div>
                <div className="main-comp-logo">
                  <img
                    className="comp-logo"
                    src={s13}
                    alt="trading companies"
                  />
                </div>
                <div className="main-comp-logo">
                  <img
                    className="comp-logo"
                    src={s14}
                    alt="trading companies"
                  />
                </div>
                <div className="main-comp-logo">
                  <img
                    className="comp-logo"
                    src={s15}
                    alt="trading companies"
                  />
                </div>
              </Slider>
            </div>
            <img className="algo-shape" src={shape1} alt="algo shape" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesDriveAlgo;
